import {
  Component,
  ChangeDetectorRef,
  ViewChild,
  Injector,
  OnInit,
  DestroyRef,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FileUploadModalComponent } from 'src/app/components/file-upload/file-upload-modal/file-upload-modal.component';
import { ProgressSpinnerDemoComponent } from 'src/app/components/progress-spinner-demo/progress-spinner-demo.component';
import { Navbar, PersonType } from 'src/app/services/models/enums';
// Services
import { AppConfigService } from 'src/app/services/app-config.service';

import { finalize, retry, skip, timer } from 'rxjs';
import { GlobalServiceService } from 'src/app/services/global/global-service.service';
import { LocalStorageService } from 'src/app/services/storage/local-storage.service';
import {
  ActiveNavbarOptions,
  getOrderByNavbarOption,
} from 'src/app/components/sidebar/sidebar-order-config';
import {
  WalletResponseDto,
  WalletService,
} from 'src/generated-sources/openapi/wallet-service/wallet';
import {
  NotificationAcknowledgeRequestDto,
  NotificationAllResponseDto,
  NotificationService,
} from 'src/generated-sources/openapi/configuration-service/notification';
import { WalletDataService } from 'src/app/services/data/wallet-data.service';
import { IndicatorDataService } from 'src/app/services/data/indicator-data.service';
import { PortfolioManagerComponent } from 'src/app/components/entity-manager/portfolio-manager/portfolio-manager.component';
import { LegacyService } from 'src/generated-sources/openapi/configuration-service/legacy';
import { LoggedUserDataService } from 'src/app/services/data/logged-user-data.service';
import { ProfileDataService } from 'src/app/services/data/profile-data.service';
import { NotifyPlanChangeDialogComponent } from 'src/app/components/data-displayer/notify-plan-change/notify-plan-change-dialog/notify-plan-change-dialog.component';
import { ProgressSpinnerService } from 'src/app/components/progress-spinner-demo/progress-spinner.service';
import { TrackingRecordRegisterDialogComponent } from 'src/app/components/entity-manager/tracking-record-register-dialog.ts/tracking-record-register-dialog.component';
import {
  ConfirmDialogResult,
  ConfirmDialogResultType,
} from 'src/app/shared/components/modals/confirmation-dialog/confirmation-dialog.component';

const navbarOptions: {
  [key in Navbar]: { text: string };
} = {
  [Navbar.dashboard]: {
    text: $localize`:@@My_table:Mi tablero`,
  },
  [Navbar.dashboardCL]: {
    text: $localize`:@@My_table:Mi tablero`,
  },
  [Navbar.dashboardCR]: {
    text: $localize`Modulo de Alertas`,
  },
  [Navbar.favoritos]: { text: $localize`Mis favoritos` },
  [Navbar.carteras]: { text: $localize`Mis carteras` },
  [Navbar.personas]: {
    text: $localize`:@@myDocuments:Mis documentos`,
  },
  [Navbar.buscar]: { text: $localize`Buscar` },
  [Navbar.buscarCL]: { text: $localize`Buscar` },
  [Navbar.orderTrackingProcessedFiles]: {
    text: $localize`:@@processed_files:Archivos Procesados`,
  },
  [Navbar.opciones]: {
    text: $localize`Configuración de Alertas`,
  },
  [Navbar.opcionesCL]: {
    text: $localize`Configuración de Alertas`,
  },
  [Navbar.adminShowSucursal]: {
    text: $localize`Modulo de sucursal`,
  },
  [Navbar.adminAddSucursal]: {
    text: $localize`Modulo de crear sucursal`,
  },
  [Navbar.adminEditSucursal]: {
    text: $localize`Modulo de editar sucursal`,
  },
  [Navbar.adminDeleteSucursal]: {
    text: $localize`Modulo de eliminar sucursal`,
  },
  [Navbar.gro]: { text: '' },
  [Navbar.ind]: { text: '' },
  [Navbar.preguntasFrecuentes]: { text: '' },
  [Navbar.attributeEvolution]: { text: '' },
  [Navbar.walletDetails]: { text: '' },
  [Navbar.walletTrend]: { text: '' },
};

enum FavoritesTab {
  WALLETS = 'WALLETS',
  DOCUMENTS = 'DOCUMENTS',
}

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
  standalone: false,
})
export class MainComponent implements OnInit {
  private readonly changeDetection: ChangeDetectorRef;
  private readonly dialog: MatDialog;
  private readonly snackBar: MatSnackBar;
  private readonly destroyRef: DestroyRef;

  public selectedFavoritesTab = FavoritesTab.WALLETS;
  showComponentNavbar: boolean = false;
  namePerson: string = '';
  firstLetterNamePerson: string = '';
  textToShow = '';
  eventSendOption: Navbar | '' = '';
  selectedWallet?: WalletResponseDto;
  isDocumentsTabSelected: boolean = false;

  attributeEvolutionData: {
    planId: string;
    documentNumber: string;
    registryId: string;
    inclusionDate: Date;
  } | null = null;

  walletTrendData: WalletResponseDto | null = null;

  @ViewChild('portfolioModal', { static: true })
  loadingModalGeneral?: ProgressSpinnerDemoComponent;
  width = window.screen.width;
  textType: string = $localize`Personas`;
  notificationPy?: string = '';
  notificationBr?: string = '';

  personType = PersonType.COMPANY;

  constructor(
    private readonly injector: Injector,
    private readonly appConfig: AppConfigService,
    private readonly walletService: WalletService,
    private readonly walletDataService: WalletDataService,
    private readonly indicatorDataService: IndicatorDataService,
    private readonly notificationService: NotificationService,
    private readonly profileDataService: ProfileDataService,
    private readonly legacyService: LegacyService,
    private readonly loggedUserDataService: LoggedUserDataService,
    private readonly localStorageService: LocalStorageService,
    private readonly progressSpinnerService: ProgressSpinnerService,
    private readonly globalService: GlobalServiceService,
  ) {
    this.changeDetection = injector.get<ChangeDetectorRef>(ChangeDetectorRef);
    this.dialog = injector.get<MatDialog>(MatDialog);
    this.snackBar = injector.get<MatSnackBar>(MatSnackBar);
    this.destroyRef = injector.get<DestroyRef>(DestroyRef);
  }

  get userCountry() {
    return this.localStorageService.getItem('userCountry');
  }

  get urlAssets() {
    return this.localStorageService.getItem('urlAssets');
  }

  get isUserAdmin(): boolean {
    return this.profileDataService.isUserAdmin();
  }

  ngOnInit() {
    this.textToShow = $localize`:@@My_table:Mi tablero`;
    this.selectedOptionNavbar(Navbar.dashboardCL);

    this.legacyService
      .legacyGetNotification()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (response) => {
          this.notificationPy = response.notification;
          this.notificationBr = response.notification;
        },
        error: () => {
          this.notificationPy = '';
          this.notificationBr = '';
        },
      });

    if (this.width > 768) {
      this.showComponentNavbar = false;
    } else {
      this.showComponentNavbar = true;
    }

    this.globalService
      .getPersonType$()
      .pipe(skip(1), takeUntilDestroyed(this.destroyRef))
      .subscribe((value) => {
        this.personType = value;
        this.reloadWallets();
        this.indicatorDataService.load();

        if (value === PersonType.COMPANY) {
          this.textType = $localize`:@@individual:Persona jurídica`;
        } else {
          this.textType = $localize`:@@legalEntity:Persona física`;
        }
      });

    this.getInitialData();

    this.loggedUserDataService
      .getUser$()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((value) => {
        if (value?.name) {
          this.namePerson = value.name;
          this.firstLetterNamePerson = value.name.substring(0, 1);
        }
      });

    const mustCheckWalletNotifications = this.appConfig.config.featureToggles.enablePlans;

    if (mustCheckWalletNotifications) {
      this.checkWalletNotifications();
    }
  }

  private checkWalletNotifications(): void {
    this.notificationService
      .listNotificationsByClientPending()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: ({ notifications }: NotificationAllResponseDto) => {
          if (notifications && notifications.length > 0) {
            const notification = notifications[0];

            if (notification) {
              const dialogRef = this.dialog.open(NotifyPlanChangeDialogComponent, {
                width: '480px',
                data: { notification: notification },
                disableClose: true,
              });

              dialogRef
                .afterClosed()
                .pipe(takeUntilDestroyed(this.destroyRef))
                .subscribe((result) => {
                  if (result && !result.showAgain) {
                    const request: NotificationAcknowledgeRequestDto = {
                      id: notification.id,
                    };

                    this.notificationService
                      .notificationAcknowledge({
                        notificationAcknowledgeRequestDto: request,
                      })
                      .pipe(takeUntilDestroyed(this.destroyRef))
                      .subscribe({
                        next: () => console.log('Notificação marcada como lida.'),
                        error: (err) => console.error('Erro ao marcar notificação como lida:', err),
                      });
                  }
                });
            }
          }
        },
      });
  }

  getInitialData() {
    return this.getPerson();
  }

  getPerson() {
    if (!this.namePerson) {
      this.namePerson = this.profileDataService.currentProfile?.userName || '';
      this.firstLetterNamePerson = this.namePerson.substring(0, 1);
    }

    this.reloadWallets(true);
    this.indicatorDataService.load();
  }

  reloadWallets(isFirstLoad = false) {
    if (isFirstLoad) {
      this.progressSpinnerService.setVisibility(true);
    }

    this.walletDataService.setIsLoading(true);

    this.walletService
      .listAll()
      .pipe(
        retry({
          count: 3,
          delay: (error, retryCount) => {
            console.warn(`Error - ${retryCount}: al obtener la Carteras -> ${error?.error}`);
            return timer(0);
          },
        }),
        finalize(() => {
          this.walletDataService.setIsLoading(false);
          isFirstLoad && this.progressSpinnerService.setVisibility(false);
        }),
      )
      .subscribe({
        next: (response) => {
          this.walletDataService.setWallets([...(response.items ?? [])]);
        },
        error: (error) => {
          console.error(`Error - al obtener la Carteras -> ${error?.error}`);
        },
      });
  }

  openRegisterModal() {
    const config = {
      minWidth: '350px',
      maxWidth: '100%',
      minHeight: '180px',
      maxHeight: '100%',
    };
    this.dialog
      .open(TrackingRecordRegisterDialogComponent, config)
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((response: ConfirmDialogResultType) => {
        if (response === ConfirmDialogResult.Confirm) {
          this.redirectAfterAddTrackingRecord();
        }
      });
  }

  openRegisterCartera() {
    const portfolioDialogRef = this.dialog.open(PortfolioManagerComponent);

    portfolioDialogRef
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((response) => {
        const createdWalletId = response?.data;

        if (!createdWalletId) return;

        this.reloadWallets();
        this.openSnackBar($localize`Cartera creada correctamente`, $localize`:@@js_Close:Cerrar`);

        this.selectedOptionNavbar(Navbar.carteras);
        this.globalService.setWalletAdded();
      });
  }

  openFileUpload() {
    this.dialog.open(FileUploadModalComponent);
  }

  getShowComponentNavbar() {
    return this.showComponentNavbar;
  }

  onResize(event: UIEvent & { target: Window }): void {
    this.width = event.target.innerWidth;
    this.showComponentNavbar = this.width <= 768;
  }

  selectedOptionNavbar(event: Navbar) {
    if (event === this.eventSendOption) return;

    this.isDocumentsTabSelected = false;
    this.globalService.alertPY = false;
    this.eventSendOption = event;

    const orderSelected = getOrderByNavbarOption(event as ActiveNavbarOptions);
    if (orderSelected) {
      this.globalService.orderSelected = orderSelected;
    }

    const option = navbarOptions[event];
    this.textToShow = option.text;

    if (event === Navbar.favoritos || event === Navbar.carteras) {
      this.selectWalletsTab();
    }
  }

  openSnackBar(message: string, action: string) {
    if (this.snackBar) {
      this.snackBar.open(message, action, { duration: 5000 });
    }
  }

  shouldShowPageHeader(): boolean {
    const optionsWithoutHeader = [
      Navbar.preguntasFrecuentes,
      Navbar.gro,
      Navbar.walletDetails,
      Navbar.ind,
      Navbar.attributeEvolution,
      Navbar.walletTrend,
    ];
    return this.eventSendOption ? !optionsWithoutHeader.includes(this.eventSendOption) : true;
  }

  redirectAfterAddTrackingRecord() {
    this.selectedOptionNavbar(Navbar.personas);
  }

  hideDisplayProgressSpinner() {
    if (this.loadingModalGeneral?.hideDisplayProgressSpinner) {
      this.loadingModalGeneral.hideDisplayProgressSpinner();
    }
  }

  selectedOptionNavbarRedirect(wallet: WalletResponseDto) {
    this.selectedWallet = wallet;

    this.selectedOptionNavbar(Navbar.walletDetails);
  }

  selectWalletsTab() {
    if (this.selectedFavoritesTab !== FavoritesTab.WALLETS) {
      this.selectedFavoritesTab = FavoritesTab.WALLETS;
      this.isDocumentsTabSelected = false;
    }
  }

  selectDocumentsTab() {
    if (this.selectedFavoritesTab !== FavoritesTab.DOCUMENTS) {
      this.selectedFavoritesTab = FavoritesTab.DOCUMENTS;
      this.isDocumentsTabSelected = true;
    }
  }

  showAttributeEvolution(data: {
    planId: string;
    documentNumber: string;
    registryId: string;
    inclusionDate: Date;
  }) {
    this.attributeEvolutionData = data;
    this.eventSendOption = Navbar.attributeEvolution;
  }

  backToPersonasList() {
    this.attributeEvolutionData = null;
    this.eventSendOption = Navbar.personas;
  }

  showWalletTrend(wallet: WalletResponseDto) {
    this.walletTrendData = wallet;
    this.eventSendOption = Navbar.walletTrend;
  }

  backToWalletList() {
    this.walletTrendData = null;
    this.eventSendOption = Navbar.carteras;
  }
}
